import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { takeLatest, put, call } from "redux-saga/effects";
import { ShowError, ShowSucess } from '../../_helper/helper';
import { getFormalApiErrorMessage } from '../../utils/apiError';

import {
  GET_LOOKUP_JOBCATEGORIES, GET_JOBCATEGORIES, GET_JOBCATEGORY_DETAILS,
  JOBCATEGORY_CREATE, JOBCATEGORY_DELETE, JOBCATEGORY_UPDATE
} from "./actionTypes";

import {
  getJobCategoriesSuccess,
  getJobCategoriesFail,
  getJobCategoryDetailsSuccess,
  getJobCategoryDetailsFail,
  createJobCategorySuccess,
  createJobCategoryFail,
  updateJobCategorySuccess,
  updateJobCategoryFail,
  deleteJobCategorySuccess,
  deleteJobCategoryFail,
  getLookupJobCategoriesSuccess,
  getLookupJobCategoriesFail,
} from "./actions";

import {
  getJobCategories,
  createJobCategory,
  deleteJobCategory,
  updateJobCategory,
  getLookupJobCategories,
  getJobCategoryDetails,
} from "../../_helper/services/jobcategory";


function* onGetJobCategories({ payload: { page, pageSize } }) {
  try {
    const response = yield call(getJobCategories, { page, pageSize });
    yield put(getJobCategoriesSuccess(response));
  } catch (error) {
    yield put(getJobCategoriesFail(error.response));
  }
}

function* onGetLookupJobCategories() {
  try {
    const response = yield call(getLookupJobCategories);
    yield put(getLookupJobCategoriesSuccess(response));
  } catch (error) {
    yield put(getLookupJobCategoriesFail(error.response));
  }
}

function* onGetJobCategoryDetails({ payload: id }) {
  try {
    let response = yield call(getJobCategoryDetails, id);
    response.nJobCategoryNo = response?.nJobCategoryNo?.trim(); // Assuming similar structure
    yield put(getJobCategoryDetailsSuccess(response));
  } catch (error) {
    yield put(getJobCategoryDetailsFail(error.response));
  }
}

function* onCreateJobCategory({ payload }) {
  try {
    const response = yield call(createJobCategory, payload);
    yield put(createJobCategorySuccess(response));


    const isUpdate = !!payload[0]?.id;

    ShowSucess(
      isUpdate ? "Job Category Updated Successfully" : "Job Category Created Successfully",
      { position: "top-right" }
    );
  } catch (error) {
    yield put(createJobCategoryFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}



function* onUpdateJobCategory({ payload: { id }, payload }) {
  try {
    const response = yield call(updateJobCategory, id, payload);
    yield put(updateJobCategorySuccess(response));
    ShowSucess("Job Category Updated Successfully", {
      position: "top-right"
    });
  } catch (error) {
    yield put(updateJobCategoryFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* onDeleteJobCategory({ payload: ID }) {
  try {
    const response = yield call(deleteJobCategory, ID);
    yield put(deleteJobCategorySuccess(response));
    ShowSucess('Deleted successfully', {
      position: 'top-right'
    });
  } catch (error) {
    yield put(deleteJobCategoryFail(error.response));
    ShowError(getFormalApiErrorMessage(error));
  }
}

function* JobCategorySaga() {
  yield takeLatest(GET_JOBCATEGORIES, onGetJobCategories);
  yield takeLatest(GET_LOOKUP_JOBCATEGORIES, onGetLookupJobCategories);
  yield takeLatest(GET_JOBCATEGORY_DETAILS, onGetJobCategoryDetails);
  yield takeLatest(JOBCATEGORY_CREATE, onCreateJobCategory);
  yield takeLatest(JOBCATEGORY_UPDATE, onUpdateJobCategory);
  yield takeLatest(JOBCATEGORY_DELETE, onDeleteJobCategory);
}

export default JobCategorySaga;
